import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import './Complaint.css';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import ComplaintDetailsSpecific from './ComplaintDetailsSpecific';
import NatureIncident from './questions/NatureIncident';

export class ComplaintDetails extends Component {

    componentWillReceiveProps(props) {

        if (props.incidentObj.discover === "") {
            this.discover.value = "";
        }

        if (props.incidentObj.additionalDetails === "") {
            this.addDetails.value = "";
        }
    }

    onDateChange = newdate => {
        this.props.incidentChanges("dateTime", newdate);
        if (newdate !== null) {
            this.props.incidentChanges("dateTimeUnknown", false);
        }
    }

    handlePhotoChoice = event => {
        this.getbase64Data(event.target.files[0]);
        this.props.incidentChanges("photoName", event.target.files[0].name);
        this.props.incidentChanges("fileType", event.target.files[0].type);
    }

    getbase64Data(file) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => (this.convertBinaryToBase64(reader.result));
    }

    convertBinaryToBase64(binaryData) {
        this.props.incidentChanges("photoFile", window.btoa(binaryData));
    }

    handleUnknownDateChange = changeEvent => {
        const prevValue = changeEvent.target.checked;
        if (prevValue) {
            this.onDateChange(null);
        }
        this.props.incidentChanges("dateTimeUnknown", prevValue);
    }

    handleRadioChange = changeEvent => {
        const name  = changeEvent.target.name;
        const value = changeEvent.target.value;
        this.props.incidentChanges(name, value);

        //sorry for hardcoding these updates to their associated text fields... tired of creating extra methods for each radio change, refactored them just to know that I can't... lol
        if (value === "no") {
            this.props.incidentChanges(name + "Specify", '');
        }
    }

    handleTextChange = changeEvent => {
        const name = changeEvent.target.name;
        const value = changeEvent.target.value;
        this.props.incidentChanges(name, value);
    }

    showDateText = () => {
        if (!this.props.incidentObj.dateTimeUnknown) {
            return null;
        }
        return <div className="col-sm-4">Please specify <span className="mandatory">(required)</span>: <input className="form-control" type="text" name="dateTimeUnknownSpecify" placeholder="e.g. every Thursday, every weekend" onBlur={this.handleTextChange} required maxLength={100}/></div>;
    }

    showEvidenceText = () => {
        if (this.props.incidentObj.evidence !== "yes") {
            return null;
        }
        return <div className="col-sm-5"><div>Please specify <span className="mandatory">(required)</span>: <input className="form-control" type="text" name="evidenceSpecify" placeholder="e.g. picture" onBlur={this.handleTextChange} required maxLength={100}/></div>
            <div>Image Upload(.jpg, .png): <input className="form-control" type="file" name="evidencePhoto" placeholder="Upload a smallish photo" onChange={this.handlePhotoChoice} accept="image/*" /></div></div>;
    }

    showInchargeText = () => {
        if (this.props.incidentObj.inCharge !== "yes") {
            return null;
        }
        return <div className="col-sm-5">Please specify:<input className="form-control" type="text" name="inChargeSpecify" placeholder="e.g. Bar Manager - Joe Smith, Owner - Jane Dane" onBlur={this.handleTextChange} maxLength={50}/></div>;
    }

    showPoliceText = () => {
        if (this.props.incidentObj.policeContact !== "yes") {
            return null;
        }
        return <div className="col-sm-5">Please specify:<input className="form-control" type="text" name="policeContactSpecify" placeholder="e.g. NY Police Department" onBlur={this.handleTextChange} maxLength={50}/></div>;
    }

    showTypes = () => {
        if (this.props.showTypeSelected.length === 0) return null;

        return <div><ul>{this.props.showTypeSelected.map(type => <li key={type}>{type}</li>)}</ul></div>;
    }

    showCDValidationMessage = () => {
        if (this.props.validationMsgCD.length === 0) return null;
        return <Alert ref="alertVisible" className="alert alert-danger" dismissible="true"><ul>{this.props.validationMsgCD.map(type => <li key={type}>{type}</li>)}</ul> </Alert>;
    }

    showNatureOfIncident = () => {
        if (this.props.showTypeSelected.indexOf("Other") > -1) {
            return <NatureIncident specificChanges={this.handleTextChange} />;
        }
        return null;
    }

    showSpecificQuestions = () => {
        if (this.props.showTypeSelected.length === 0) return null;
        return <ComplaintDetailsSpecific
            incidentObj={this.props.incidentObj}
            typename={this.props.showTypeSelected}
            incidentSpecificChanges={this.props.incidentChanges}
        />;
    }

    render() {
        return (
            <div className="container">
                <div className="row mt-5">
                    <fieldset id="step2">
                        <legend><span className="fieldset-legend">Step 3 of 4 - Complaint Details</span></legend>
                        <div className="col-sm-12">
                            <h3>Please tell us more about the incident to the best of your knowledge.</h3>
                            <div className="col-sm-12">
                                <br />
                                {this.showCDValidationMessage()}
                            </div>
                            <div className="form-group mt-2">
                                <div className="form-group row" >
                                    <input type="hidden" name="PremisesId" value={0} />
                                </div>
                                {this.showNatureOfIncident()}
                                <div className="form-horizontal row" >
                                    <label className=" control-label col-md-4" htmlFor="DateTime">Date and time the incident occured: </label>
                                    <div className="col-sm-3">
                                        <DatePicker
                                            selected={this.props.incidentObj.dateTime}
                                            onChange={this.onDateChange}
                                            showTimeSelect
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                            timeCaption="time"
                                            className="form-control wider-datepicker"
                                            placeholderText="Choose Date/Time"
                                        />
                                    </div>
                                    <div className="col-sm-1 noSpace">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="dateTimeUnknown"
                                                onChange={this.handleUnknownDateChange}
                                                value={this.props.incidentObj.dateunknown}
                                                checked={this.props.incidentObj.dateunknown}
                                            /> Unknown
                                            </label>
                                    </div>
                                    {this.showDateText()}
                                </div>
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-md-4" htmlFor="Evidence">Do you have any evidence of the incident(s)?</label>
                                    <div className="col-sm-3">
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="evidence"
                                                    value="yes"
                                                    checked={this.props.incidentObj.evidence === "yes"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> Yes
                                                </label>
                                        </div>
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="evidence"
                                                    value="no"
                                                    checked={this.props.incidentObj.evidence === "no"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> No
                                            </label>
                                        </div>
                                    </div>
                                    {this.showEvidenceText()}
                                </div>
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Discover">How do you know about the incident(s)?</label>
                                    <div className="col-sm-8">
                                        <textarea className="form-control" rows="3" type="text" name="discover" onBlur={this.handleTextChange} ref={el => this.discover = el} />
                                    </div>
                                </div >
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Incharge">Do you know who was in charge of the establishment at that time?</label>
                                    <div className="col-sm-3">
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="inCharge"
                                                    value="yes"
                                                    checked={this.props.incidentObj.inCharge === "yes"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> Yes
                                                </label>
                                        </div>
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="inCharge"
                                                    value="no"
                                                    checked={this.props.incidentObj.inCharge === "no"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> No
                                            </label>
                                        </div>
                                    </div>
                                    {this.showInchargeText()}
                                </div >
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-md-4" htmlFor="Police" >Were the police contacted?</label>
                                    <div className="col-sm-3">
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="policeContact"
                                                    value="yes"
                                                    checked={this.props.incidentObj.policeContact === "yes"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> Yes
                                                </label>
                                        </div>
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="policeContact"
                                                    value="no"
                                                    checked={this.props.incidentObj.policeContact === "no"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> No
                                            </label>
                                        </div>
                                        <div className="form-horizontal">
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="policeContact"
                                                    value="unknown"
                                                    checked={this.props.incidentObj.policeContact === "unknown"}
                                                    onChange={this.handleRadioChange}
                                                    className="form-check-input"
                                                /> Unknown
                                            </label>
                                        </div>
                                    </div>
                                    {this.showPoliceText()}
                                </div>
                                {this.showSpecificQuestions()}
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Additional">Provide any additional details:</label>
                                    <div className="col-sm-8">
                                        <textarea className="form-control" rows="5" type="text" name="additionalDetails" onBlur={this.handleTextChange}
                                            ref={el => this.addDetails = el}
                                        />
                                    </div>
                                </div >
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        );
    }
}

export default ComplaintDetails;




// WEBPACK FOOTER //
// ./src/components/ComplaintDetails.js